var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-item"},[_c('img',{attrs:{"src":_vm.getAssetsPath(_vm.srcPath),"alt":"avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }